export const policyValues = {
  none: "none",
  create: "add",
  read: "read",
  update: "edit",
  delete: "delete"
};
